import * as React from 'react';
import { connect } from 'react-redux';
import { Permissions } from '../../models/enums/permissions';
import { IApplicationState } from '../../store/IApplicationState';
import { validatePermission } from './validate-permission';

// #region Component Props

interface IProps {
    currentPermissions  : Permissions[];
    children            : any;
    requiredPermissions : Permissions[];
}

// #endregion

/**
 * Component for hiding content based on user roles
 */
class HasPermissionComponent extends React.Component<IProps> {

    public static defaultProps = {
        currentPermissions: [],
        requiredPermissions: []
    };

    public render() {

        const isAuthed = validatePermission({
            currentPermissions  : this.props.currentPermissions,
            requiredPermissions : this.props.requiredPermissions
        });

        return isAuthed ? <React.Fragment>{ this.props.children }</React.Fragment> : null;
    }

}

const mapStateToProps = (extendState = {}) => (state: IApplicationState) => {
    return {
        currentPermissions: state.userdata.user.permissions,
        ...extendState
    };
};

const HasPermission = connect(
    mapStateToProps,
    null
)(HasPermissionComponent);

export { HasPermission };
